module.exports = __webpack_public_path__ + "img/monitorbox29.04509daf.jpg";